<section class="block videos default-padding js-videos margin--bottom-l margin--top-l">
  <div class="default-max-width centered">
    <div class="videos-title headline-second bright-text">{{ data.title }}</div>

    <div class="video-items inline-container">
      <div class="videos-videos inline-top">
        <div class="videos-videos-inner">
          <div
            class="videos-video js-videos-video"
            *ngFor="let video of data.videos; let index = index"
            [ngClass]="{ active: activeVideo === index }"
          >
            <app-youtube
              *ngIf="activeVideo === index && video.videoProvider === 'Youtube'"
              [code]="video.externalId"
              [poster]="video.large"
            ></app-youtube>
            <app-vimeo
              *ngIf="activeVideo === index && video.videoProvider === 'Vimeo'"
              [code]="video.externalId"
              [poster]="video.large"
            ></app-vimeo>
          </div>
        </div>
      </div>

      <div class="videos-navigation inline-top">
        <div
          class="videos-navigation-item js-videos-navigation-item"
          [ngClass]="{ active: activeVideo === index }"
          *ngFor="let video of data.videos; let index = index"
          (click)="activate(index)"
        >
          <div class="videos-navigation-item-inner">
            <div class="videos-navigation-item-title headline-third bright-text">
              {{ video.title }}
            </div>

            <div class="flex videos-navigation-item-infos flex--jc-space-between default-font-sizes default-font-sizes--very-small">
              <div>
                {{ video.description }}
              </div>
            </div>
          </div>
        </div>

        <div class="videos-navigation-arrows">
          <button class="videos-navigation-arrow js-videos-navigation-arrow" data-action="prev" (click)="prev()">
            <i class="icon-arrow-6"></i>
          </button>

          <button class="videos-navigation-arrow js-videos-navigation-arrow" data-action="next" (click)="next()">
            <i class="icon-arrow-6"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
